import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import { useForm } from "react-hook-form";
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Check } from '../../Img/icon-check.svg';


const Annees_retro_prosp = (props) =>
{
    const [aff, setAff] = useState(false);
    const [retro_an_deb, setRetro_an_deb] = useState('');
    const [retro_an_fin, setRetro_an_fin] = useState('');
    const [prosp_an_deb, setProsp_an_deb] = useState('');
    const [prosp_an_fin, setProsp_an_fin] = useState('');

    const green = '#59B44A';
    const purple = '#6571FE';

    useEffect(() => {
        if (!props.user) {
            props.getUser()
        }
        else {
            if (props.user.id_budget != undefined)
            {
                // Récupération des années du config_budget
                axios.get('https://app-slfinance.fr/api/config_budget.php?id_budget='+props.user.id_budget)
                .then(async(result) => {
                    var tmp_retro_an_deb = '';
                    var tmp_retro_an_fin = '';
                    var tmp_prosp_an_deb = '';
                    var tmp_prosp_an_fin = '';

                    await result.data.forEach(budget => {
                        if (budget[2] === 'retro_an_deb') {
                            tmp_retro_an_deb = budget[3]
                            setRetro_an_deb(tmp_retro_an_deb)
                        }
                        if (budget[2] === 'retro_an_fin') {
                            tmp_retro_an_fin = budget[3]
                            setRetro_an_fin(tmp_retro_an_fin)
                        }
                        if (budget[2] === 'prosp_an_deb') {
                            tmp_prosp_an_deb = budget[3]
                            setProsp_an_deb(tmp_prosp_an_deb)
                        }
                        if (budget[2] === 'prosp_an_fin') {
                            tmp_prosp_an_fin = budget[3]
                            setProsp_an_fin(tmp_prosp_an_fin)
                        }
                    });
    
                    // S'il n'y a pas d'années enregistré on prend celles de base
                    if (tmp_retro_an_deb === '' || tmp_retro_an_fin === '' || tmp_prosp_an_deb === '' || tmp_prosp_an_fin === '') {
                        await axios.post("https://app-slfinance.fr/api/application.php", qs.stringify({'get': true}))
                        .then(function (ret) {
                            if (tmp_retro_an_deb === '') {
                                setRetro_an_deb(ret.data.retro_an_deb)
                            }
                            if (tmp_retro_an_fin === '') {
                                setRetro_an_fin(ret.data.retro_an_fin)
                            }
                            if (tmp_prosp_an_deb === '') {
                                setProsp_an_deb(ret.data.prosp_an_deb)
                            }
                            if (tmp_prosp_an_fin === '') {
                                setProsp_an_fin(ret.data.prosp_an_fin)
                            }
                        })
                        .catch((err) => {
                            console.warn(err)
                        })
                    }
                })
                .catch((err) => {
                    console.warn(err)
                })
            }
        }
    }, [props.user, props.budget])


    function valider()
    {
        // Vérification des valeurs avant de les envoyer à l'API
        if (retro_an_deb === '' || retro_an_fin === '' || prosp_an_deb === '' || prosp_an_fin === '') {
            NotificationManager.warning("Veuillez renseigner les champs", '', 3000);
        }
        else
        {
            if (retro_an_fin < retro_an_deb) {
                NotificationManager.warning("L'année de début ne doit pas être supérieure à l'année de fin", '', 3000);
            }
            if (prosp_an_fin <= retro_an_fin) {
                NotificationManager.warning("L'année de fin de prospective ne doit pas être inferieure ou égale à l'année de fin de retrospective", '', 5000);
            }
            if (retro_an_fin >= retro_an_deb && prosp_an_fin > retro_an_fin)
            {
                var objet = {
                    'retro_an_deb': retro_an_deb,
                    'retro_an_fin': retro_an_fin,
                    'prosp_an_deb': prosp_an_deb,
                    'prosp_an_fin': prosp_an_fin
                }
                axios.post('https://app-slfinance.fr/api/config_budget.php', qs.stringify({
                    'set_config_budget_objet': true,
                    'id_budget': props.user.id_budget,
                    'objet': objet
                }))
                .then((res) => {
                    if (res.data['status'] === 1) {
                        NotificationManager.success(res.data['status_message'], '', 2000);
                    }
                    else {
                        NotificationManager.warning(res.data['status_message'], '', 2000);
                    }
                })
                .catch((err) => {
                    console.warn(err)
                })
            }
        }
    }

    return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Années de rétrospective et de prospective</p>
                </div>

                {/* module pour afficher et modifier les années de rétrospective et de prospective */}
                {props.user &&
                <div style={{flex: 1, margin: 10}}>
                    <div className='shadow-md' style={{textAlign: 'center', height: '100%',  borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white'}}>
                            
                        <p style={{fontWeight: 'bold', fontSize: 16, padding: 10, color: purple}}>Modifier les années de rétrospective et prospective:</p>
        
                        <div style={{display: 'flex', textAlign: 'left', padding: 10, marginTop: 20}}>
                            <div style={{flex: 1, textAlign: 'center'}}>
                                <p>Rétrospective:</p>
                                <div style={{margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <p>Début de la rétrospective :</p>
                                    <input
                                    onBlur={(e) => {
                                        const v = e.target.value;
                                        if (v !== '' && !isNaN(parseInt(v))) {
                                            setRetro_an_deb(parseInt(v).toString());
                                        }
                                    }}
                                    style={{width: 150, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, marginLeft: 5}}
                                    placeholder={retro_an_deb?retro_an_deb:''}
                                    disabled={(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') ? false : true}
                                    />
                                </div>
                                <div style={{margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <p>Fin de la rétrospective :</p>
                                    <input
                                    onBlur={(e) => {
                                        const v = e.target.value;
                                        if (v !== '' && !isNaN(parseInt(v))) {
                                            const newRetroFin = parseInt(v).toString();
                                            setRetro_an_fin(newRetroFin);
                                            // recalculer immédiatement le début de la prospective à partir de la nouvelle valeur
                                            setProsp_an_deb((parseInt(newRetroFin) + 1).toString());
                                        }
                                    }}
                                    style={{width: 150, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, marginLeft: 5}}
                                    placeholder={retro_an_fin?retro_an_fin:''}
                                    disabled={(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') ? false : true}
                                    />
                                </div>
                            </div>
                            <div style={{flex: 1, textAlign: 'center', borderLeft: '1px solid black'}}>
                                <p>Prospective:</p>
                                <div style={{margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <p>Début de la prospective :</p>
                                    <input
                                    style={{width: 150, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, marginLeft: 5}}
                                    placeholder={prosp_an_deb?prosp_an_deb:''}
                                    disabled
                                    />
                                </div>
                                <div style={{margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <p>Fin de la prospective :</p>
                                    <input
                                    onBlur={(e) => {
                                        const v = e.target.value;
                                        if (v !== '' && !isNaN(parseInt(v))) {
                                            setProsp_an_fin(v.toString());
                                        }
                                        // assure la cohérence du début de prospective
                                        setProsp_an_deb((parseInt(retro_an_fin || '0') + 1).toString());
                                    }}
                                    style={{width: 150, border: '1px solid #E9ECEF', borderRadius: 5, padding: 7, marginLeft: 5}}
                                    placeholder={prosp_an_fin?prosp_an_fin:''}
                                    disabled={(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') &&
                        <div style={{margin: 10, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                            <button
                            style={{display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, paddingLeft: 10, paddingRight: 10, alignItems: 'center', justifyContent: 'center'}}
                            onClick={() => {
                                valider();
                            }}
                            >
                                <Check width="12" />
                                <p style={{marginLeft: 5}}>Valider</p>
                            </button>
                        </div>
                        }
                    </div>
                </div>
                }

            </Access>
        </div>
    );
}

export default Annees_retro_prosp;
